export default __webpack_public_path__ + "static/media/MaintenanceBackground.9dd17149.svg";